import React, { useState } from "react";

const SetLeagueChatModal = ({
  isOpen,
  onClose,
  onSetChatUrl,
  initialUrl = "",
}) => {
  const [chatUrl, setChatUrl] = useState(initialUrl);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSetChatUrl(chatUrl);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-dark-grey bg-opacity-75 flex justify-center items-center px-4 py-6">
      <div className="bg-white bg-dark-gray-800 p-6 rounded-lg shadow-lg max-w-sm w-full">
        <form onSubmit={handleSubmit}>
          <h3 className="text-lg font-semibold text-dark-grey">
            Set League Chat URL
          </h3>
          <input
            type="text"
            value={chatUrl}
            onChange={(e) => setChatUrl(e.target.value)}
            placeholder="Chat URL"
            className="w-full p-2 mt-4 border rounded border-medium-grey"
          />
          <div className="mt-4 flex justify-end space-x-4">
            <button
              type="button"
              onClick={onClose}
              className="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-dark-grey bg-light-grey hover:bg-medium-grey"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-deep-red hover:bg-bright-red"
            >
              Set Chat URL
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SetLeagueChatModal;
